import React, { useState, useEffect } from 'react'
import { Alert, Snackbar, AlertColor } from '@mui/material'
import type { Flash } from '@/types'

interface FlashMessagesProps {
  flash: Flash
}

export default function FlashMessages({ flash }: FlashMessagesProps) {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState<string | null>(null)
  const [severity, setSeverity] = useState<AlertColor>('success')

  useEffect(() => {
    if (flash?.notice) {
      setMessage(flash.notice)
      setSeverity('success')
      setOpen(true)
    } else if (flash?.alert) {
      setMessage(flash.alert)
      setSeverity('error')
      setOpen(true)
    }
  }, [flash])

  if (!message) return null

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert severity={severity} onClose={() => setOpen(false)} variant="filled" sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  )
}
